import { BlueBtn } from '__components/BlueBtn';
import Mask from '__components/Mask';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';

interface Props {
  onPress?: Function;
}

interface State {
  isShow: boolean;
}

export class NoAwardPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  show = () => {
    this.setState({ isShow: true });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { onPress } = this.props;
    const { isShow } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0.02 }}
                end={{ x: 0, y: 0.31 }}
                colors={['#FFF7C2', '#FFFFFF']}
                style={styles.main}
              >
                <Spacer size={rpx(25)} />
                <Text style={styles.text}>很遗憾,没抽中奖品</Text>
                <Spacer size={rpx(25)} />
                <EmTouchableOpacity
                  activeOpacity={0.9}
                  onPress={() => {
                    onPress && onPress();
                    this.hide();
                  }}
                >
                  <Image
                    style={styles.bottomBtn}
                    source={require('../../images/invite/iKnow.png')}
                    resizeMode={'stretch'}
                  />
                </EmTouchableOpacity>
                <Spacer size={rpx(30)} />
              </LinearGradient>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: rpx(300),
    backgroundColor: '#fff',
    borderRadius: rpx(12),
    alignItems: 'center',
  },
  text: {
    fontSize: rpx(24),
    color: '#333333',
    lineHeight: rpx(30),
    fontWeight: 'bold',
  },
  taskBtn: {
    width: rpx(250),
    height: rpx(40),
    borderRadius: rpx(20),
    alignItems: 'center',
    justifyContent: 'center',
  },
  bottomBtn: {
    width: rpx(210),
    height: rpx(51),
  },
});
